import { TRACKS_URL } from '@/modules/track/track.constants';
import { resolveCurrentUser } from '@/modules/user/user.service';
import { createEmptyComponent } from '@/router/route.service';

export default [
  {
    path: TRACKS_URL.path,
    redirect: '/',
    beforeEnter: resolveCurrentUser,
    component: { render: createEmptyComponent },
    children: [
      {
        ...TRACKS_URL.view,
        component: () => import('@/modules/track/views/TrackViewPage.vue'),
      },
      {
        ...TRACKS_URL.edit,
        component: () => import('@/modules/track/views/TrackEditPage.vue'),
      },
      {
        ...TRACKS_URL.create,
        component: () => import('@/modules/track/views/TrackEditPage.vue'),
      },
      {
        ...TRACKS_URL.notfound,
        component: () => import('@/modules/track/views/TrackNotFound.vue'),
      },
      {
        ...TRACKS_URL.forbidden,
        component: () => import('@/modules/track/views/TrackForbidden.vue'),
      },
      {
        ...TRACKS_URL.denied,
        component: () => import('@/modules/track/views/TrackDenied.vue'),
      },
    ],
  },
];

export function goToForbiddenTrack($router, creating) {
  $router.push({
    name: TRACKS_URL.forbidden.name,
    params: { creating },
  });
}

export function goToDeniedTrack($router) {
  $router.push({
    name: TRACKS_URL.denied.name,
  });
}

export function goToTrackNotFound($router) {
  $router.push({
    name: TRACKS_URL.notfound.name,
  });
}

export function goToOpenTrack($router, track) {
  $router.push({
    name: TRACKS_URL.view.name,
    params: { id: track.id },
    query: { name: track.slug },
  });
}

export function goToCreateTrack($router) {
  $router.push({
    name: TRACKS_URL.create.name,
  });
}
